<template>
    <div>

        <div class="m-2">
            <!-- Table Top -->
            <b-row>
                <!-- Per Page -->
                <b-col cols="12" lg="4" md="12" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                    <slot name="create">
                        <b-button v-if="create" variant="primary" :to="create">
                            {{ createText || 'Opret ny' }}
                        </b-button>
                    </slot>
                </b-col>

                <!-- Search -->
                <b-col cols="12" lg="8" md="12" xl="6" v-if="filter">
                    <div class="d-flex align-items-center justify-content-end">
                        <b-form-input v-model="searchQuery"
                                      class="d-inline-block mr-1"
                                      placeholder="Søg..." />

                        <slot name="filter"></slot>
                    </div>
                </b-col>
            </b-row>
        </div>


        <b-table ref="dataTable"
                 :items="getItems"
                 :per-page="perPage"
                 :current-page="currentPage"
                 responsive
                 :fields="columns"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 show-empty
                 empty-text="Ingen resultater fundet"
                 class="position-relative">


            <template v-for="item in columnKeys" v-slot:[item]="data">
                <slot :name="data.field.key" v-bind="data" >{{data.value}}</slot>
            </template>

        </b-table>


        <div class="mx-20 mb-20">
            <b-row>
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                    <span class="text-muted">Viser {{paging.from}} til {{paging.to}} af {{paging.of}} resultater</span>
                </b-col>
                <!-- Pagination -->
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

                    <b-pagination v-model="currentPage"
                                  :total-rows="totalItems"
                                  :per-page="perPage"
                                  first-number
                                  last-number
                                  class="mb-0 mt-5 mt-sm-0"
                                  prev-class="prev-item"
                                  next-class="next-item">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>

                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            url: {
                type: String,
                required: true
            },
            columns: {
                type: Array,
                default: () => [],
            },
            create: {
                type: String,
                default: null
            },
            createText: {
                type: String,
                default: null
            },
            perPage: {
                type: Number,
                default: 10,
            },
            filter: {
                type: Object,
                default: null
            },
            cacheSearch: {
                type: String,
                default: null
            },
            sort: {
                type: String,
                default: null
            },
            desc: {
                type: Boolean,
                default: true
            }
        },
        data: () => ({
            searchQuery: null,

            currentPage: 1,
            totalItems: 0,
            totalPages: 0,
            sortBy: "",
            sortDesc: false,

            init: false
        }),
        computed: {
            columnKeys() {
                return this.columns.map(x => "cell(" + x.key + ")")
            },
            paging() {
                var localItemsCount = this.$refs.dataTable ? this.$refs.dataTable.localItems.length : 0
                return {
                    from: this.perPage * (this.currentPage - 1) + (localItemsCount ? 1 : 0),
                    to: this.perPage * (this.currentPage - 1) + localItemsCount,
                    of: this.totalItems,
                }
            }
        },
        watch: {
            searchQuery() {
                if (this.init) {
                    this.$refs.dataTable.refresh()
                }
            },
            filter: {
                handler() {
                    if (this.init) {
                        this.$refs.dataTable.refresh()
                    }
                },
                deep: true
            }
        },
        created() {
            if (this.sort) {
                this.sortBy = this.sort
            }
            this.sortDesc = this.desc

            if (this.cacheSearch && localStorage) {
                var searchCache = localStorage.getItem(this.cacheSearch)
                if (searchCache) {
                    try {
                        var searchFilter = JSON.parse(searchCache)

                        this.searchQuery = searchFilter.search ? searchFilter.search : ""
                        this.currentPage = searchFilter.currentPage
                        this.sortBy = searchFilter.sortBy
                        this.sortDesc = searchFilter.sortDesc

                        this.$emit("update:filter", searchFilter.filter)

                    } catch (error) { }
                }
            }

            this.init = true
        },
        mounted() { },
        methods: {
            getItems(ctx) {
                var postData = {
                    search: this.searchQuery,
                    currentPage: ctx.currentPage,
                    perPage: ctx.perPage,
                    sortBy: ctx.sortBy,
                    sortDesc: ctx.sortDesc,
                    filter: this.filter
                }

                let promise = this.$http.post(this.url, postData)

                if (this.cacheSearch && localStorage) {
                    localStorage.setItem(this.cacheSearch, JSON.stringify(postData))
                }

                return promise.then(x => {
                    var items = x.data.items
                    this.totalItems = x.data.total
                    this.totalPages = x.data.pages

                    return items || []
                })
            },
            refresh() {
                this.$refs.dataTable.refresh()
            }
        },
    }
</script>